import React, { Suspense } from 'react';
import './index.scss';
import Navbar from '@/components/Navbar';
import NewInfo from './components/NewInfo';
import { closeWebPage } from '@/utils';

const Workbench = function () {
  localStorage.removeItem('isShowPickPopup');
  localStorage.removeItem('isShowSpiderWebPickPopup');
  return (
    <React.Fragment>
      <Navbar
        bgColor="#3C6EF0"
        title="无人车工具"
        fontColor="#fff"
        btnColor="#fff"
        showRightBtn={true}
        onBack={closeWebPage}
      />
      <Suspense fallback={<div>加载中...</div>}>
        <NewInfo />
      </Suspense>
    </React.Fragment>
  );
};

export default Workbench;
